import { Pipe, PipeTransform } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

@Pipe({
  name: 'formControlGetter',
})
export class FormControlGetterPipe implements PipeTransform {
  transform(
    formArray :UntypedFormArray,
    index :number,
    controlName :string,
  ) :UntypedFormControl {
    return formArray && formArray.at(index)
      ? ((formArray.at(index) as UntypedFormGroup).get(
          controlName,
        ) as UntypedFormControl)
      : new UntypedFormControl();
  }
}
